export const fieldType = { tel: 10, otp: 1, pin: 6 };
export const titleOptions = ["Dr.", "Mr.", "Mrs.", "Miss"];
export const titleOptionsNew = [{ key: "Dr.", value: "Dr." }, { key: "Mr.", value: "Mr." }, { key: "Mrs.", value: 'Mrs.' }, { key: "Ms.", value: 'Ms.' }, { key: "Prof.", value: 'Prof.' }];
export const phoneField = "phoneNumber";
export const universitySchoolCompanyName = ["Name of company/university/school", "Test_University1", "Test_University2"]
export const stream = ["Select Stream", "Test_Stream1", "Test_Stream2"]
export const specialization = ["Select Specialization Field", "Test_Specialization1", "Test_Specialization2"]
export const qualification = ["Qualification/Level", "Test_Qualification1", "Test_Qualification2"]
export const workCategories = ["Select Category", "Test_WorkCatogery1", "Test_WorkCatogery2"]
export const ProfileSetUpcity = ['City', 'Indore', 'Mumbai', 'Delhi'];
export const PaymentMode = ["UPI", "Debit Card"];
export const feedbackTextValues = {
    1: "Oh no! You are upset. Sorry to hear this. Please help us fix it",
    2: "So sorry to know that you are not pleased. Tell us why",
    3: "We are sorry you're not completely happy. How can we help?",
    4: "You are happy and we are smiling. Tell us what we did right!",
    5: "YAY!! This is what we live for. Tell us what delighted you!"
};

export const serviceOffered = [{ id: 'Copy_Editing_123', name: 'Copy Editing' },
{ id: 'Graphics_&_Design_123', name: "Graphics & Design" },
{ id: 'Book_Cover_Design_123', name: 'Book Cover Design' },
{ id: 'Social_Media_123', name: 'Social Media' },
{ id: 'Content_Creator_123', name: 'Content Creator' },
{ id: "SEO_123", name: 'SEO' }
];
export const profesionalPrefrence = [{
    professionalKey: "dribble",
    link: "",
    subscribe: false
},
{
    professionalKey: "vimeo",
    link: "",
    subscribe: true
},
{
    professionalKey: "youtube",
    link: "",
    subscribe: "true"
}]
export const Skills = ['react', 'javascript', 'nodejs']
export const Experience = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "More than 10"];